import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const SHARED_DATA_KEY = 'sharedData';
const ANALYTIC_DATA_KEY = 'analyticData';

@Injectable({
    providedIn: 'root'
})
export class ShareDataService {

    private sharedData = new BehaviorSubject<any>(this.getFromStorage(SHARED_DATA_KEY));
    sharedData$ = this.sharedData.asObservable();

    private analyticData = new BehaviorSubject<any>(this.getFromStorage(ANALYTIC_DATA_KEY));
    analyticData$ = this.analyticData.asObservable();

    constructor() {}

    private getFromStorage(key: string): any {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    }

    setSharedData(data: any) {
        this.sharedData.next(data);
        localStorage.setItem(SHARED_DATA_KEY, JSON.stringify(data));
    }

    setAnalyticData(data: any) {
        this.analyticData.next(data.payload);
        localStorage.setItem(ANALYTIC_DATA_KEY, JSON.stringify(data.payload));
    }

    clearSharedData() {
        this.sharedData.next(null);
        this.analyticData.next(null);
        localStorage.removeItem(SHARED_DATA_KEY);
        localStorage.removeItem(ANALYTIC_DATA_KEY);
    }
}
